import { Clock3, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { Brand } from "./Brand";
import { brand } from "../config/brand";

export function SiteFooter() {
  return (
    <footer className="site-footer">
      <div className="poncho-line" aria-hidden="true" />
      <div className="container footer-grid">
        <div className="footer-brand">
          <Brand compact />
          <p>
            <strong>{brand.motto}.</strong> Información, servicios y participación
            ciudadana en un solo lugar.
          </p>
          <strong>Una Municipalidad presente, clara y accesible</strong>
        </div>
        <div>
          <h2>Atención</h2>
          <ul className="contact-list">
            <li>
              <MapPin aria-hidden="true" /> Piribebuy, Cordillera, Paraguay
            </li>
            <li>
              <Clock3 aria-hidden="true" /> Lun. a vie., 07:00 a 13:00
            </li>
          </ul>
        </div>
        <div>
          <h2>Enlaces institucionales</h2>
          <ul>
            <li>
              <Link to="/intendencia">Intendencia</Link>
            </li>
            <li>
              <Link to="/tramites">Trámites</Link>
            </li>
            <li>
              <Link to="/transparencia">Transparencia</Link>
            </li>
            <li>
              <Link to="/estado-servicios">Estado de servicios</Link>
            </li>
          </ul>
        </div>
        <div>
          <h2>Uso responsable</h2>
          <ul>
            <li>
              <Link to="/accesibilidad">Accesibilidad</Link>
            </li>
            <li>
              <Link to="/privacidad">Privacidad</Link>
            </li>
            <li>
              <Link to="/terminos">Términos de uso</Link>
            </li>
            <li>
              <Link to="/informacion-proyecto">Información del proyecto</Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <div className="container">
          <span>Gobierno Municipal de Piribebuy.</span>
          <span>Desarrollado por Arandu Dev.</span>
        </div>
      </div>
    </footer>
  );
}

